import { Route } from 'react-router-dom'

import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'

import MonitoringSsids from './MonitoringSsids'

const MonitoringSsidsRoutes = () => [
  <Route
    path="monitoring-ssids"
    key="monitoring-ssids"
    element={
      <RouteGuard requiredRoles={['ssid_monitoring', 'ssid_monitoring_ro']}>
        <MonitoringSsids />
      </RouteGuard>
    }
  />
]

export default MonitoringSsidsRoutes
